import Splide from '@splidejs/splide';

const EL = '.js-MediaDoubleCarousel'

if(document.querySelector(EL)){
  const carousel = new Splide( EL, {
    type: 'fade',
    rewind: true,
    arrows: false,
    pagination: true
  } )

  carousel.mount();
}
